import React from 'react';

export const DocDetalle = ({ fileName, fileSize, onDelete }) => {


    return (
        <div className="doc-detalle">
            <span className="material-symbols-outlined">description</span>
            <p className="txt">
                {fileName} <span className="size">{fileSize}</span>
            </p>
            <button className="delete-file" type="button" role="delete" onClick={onDelete}>
                <span className="material-symbols-outlined">delete</span>
            </button>
        </div>
    );
};
